import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { AlertsService } from './alerts.service';
import { Alert } from './Alert';

@Component({
	// tslint:disable-next-line
	selector: 'alerts',
	styleUrls: [
		'./alerts.css'
	],
	encapsulation: ViewEncapsulation.None,
	template:
		`<div [hidden]='alerts.length === 0' style="margin-bottom:12px;">
			@for (alert of alerts; track alert.id) {
				<div class="flex items-start justify-between gap-2 rounded-md px-3 py-2 text-sm mb-2"
					[style.background-color]="alert.alertType === 'error' ? '#fef2f2' : alert.alertType === 'success' ? '#f0fdf4' : alert.alertType === 'warning' ? '#fffbeb' : '#eff6ff'"
					[style.border]="alert.alertType === 'error' ? '1px solid #fca5a5' : alert.alertType === 'success' ? '1px solid #86efac' : alert.alertType === 'warning' ? '1px solid #fcd34d' : '1px solid #93c5fd'"
					[style.color]="alert.alertType === 'error' ? '#b91c1c' : alert.alertType === 'success' ? '#15803d' : alert.alertType === 'warning' ? '#92400e' : '#1d4ed8'">
					<span>{{ alert.message }}</span>
					<button type="button" (click)="closeAlert(alert)" style="flex-shrink:0; opacity:0.6; line-height:1;" class="hover:opacity-100 transition-opacity">
						<svg style="width:14px;height:14px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
						</svg>
					</button>
				</div>
			}
		</div>`,
	standalone: false,
})
export class AlertsComponent implements OnInit {
	@Input('namespace') nameSpace: string;

	private _alerts: Alert[];

	constructor(
		private alertsService: AlertsService
	) {
	}

	ngOnInit(): void  {
		this.alerts = this.alertsService.getAlerts(this.nameSpace);
		this.alertsService.subscribeToAlerts(
			() => {
				this.alerts = this.alertsService.getAlerts(this.nameSpace);
			}
		);
	}

	closeAlert(alertToClose: Alert) {
		this.alertsService.closeAlertByRef(alertToClose);
	}

	get alerts(): Alert[] {
		return this._alerts;
	}

	set alerts(newAlerts: Alert[]) {
		this._alerts = newAlerts;
	}
}
